import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=124f69b4&"
import script from "./Map.vue?vue&type=script&lang=js&"
export * from "./Map.vue?vue&type=script&lang=js&"
import style0 from "./Map.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../BuildingCatalog/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports